import { useContext } from 'react'
import styled from 'styled-components'

import { BottomSheetContext } from '../../provider/BottomSheetProvider'

import { AlignCenterItem } from '../common'
import { BottomSheet } from '../bottomSheet'
import { Text } from '../text'

import { Color } from '../../theme/color'

import { ReactComponent as CloseIcon } from '../../assets/ico/common/close/close_black.svg'
import { ReactComponent as DropdownIcon } from '../../assets/ico/common/dropdown_18.svg'

interface SortProps<T> {
  sortType: T
  sortList: { type: T; title: string }[]
  setSortType: (type: T) => void
}

export function Sort<T>({ sortType, sortList, setSortType }: SortProps<T>) {
  const { showBottomSheet, hideBottomSheet } = useContext(BottomSheetContext)

  const selectedItem = sortList.find((v) => v.type === sortType)

  const showSortListBottomSheet = () => {
    showBottomSheet({
      Component: () => (
        <BottomSheet>
          <Header>
            <Text size={20} weight={600} block={true} $textAlign="center">
              정렬 순서
            </Text>
            <CloseIcon onClick={hideBottomSheet} />
          </Header>
          <SortList>
            {sortList.map(({ type, title }, index) => {
              const isActive = sortType === type

              const select = () => {
                setSortType(type)
                hideBottomSheet()
              }

              return (
                <Item key={index} onClick={select}>
                  <Text size={16} weight={isActive ? 700 : 500} color={isActive ? 'primary_5' : 'text_secondary'}>
                    {title}
                  </Text>
                </Item>
              )
            })}
          </SortList>
        </BottomSheet>
      ),
    })
  }

  return (
    <Container onClick={showSortListBottomSheet}>
      <Text size={14} weight={500} color="text_secondary">
        {selectedItem?.title}
      </Text>
      <DropdownIcon onClick={hideBottomSheet} />
    </Container>
  )
}

const Container = styled(AlignCenterItem)`
  cursor: pointer;
`

const Header = styled.div`
  position: relative;
  width: calc(100% - 48px);
  margin: 32px 24px 8px;
  padding-bottom: 18px;
  border-bottom: 1px solid ${Color.line};
  > svg {
    position: absolute;
    top: 0;
    right: 0;
    cursor: pointer;
  }
`

const SortList = styled.ul`
  padding-bottom: calc(24px + env(safe-area-inset-bottom));
`

const Item = styled.li`
  padding: 16px 0;
  text-align: center;
  list-style: none;
  cursor: pointer;
`
